import Breadcrumb from '../Breadcrumb';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';
import { useEffect } from 'react';
import BrandSection from '../Section/BrandSection';
import ContactSectionStyle2 from '../Section/ContactSection/ContactSectionStyle2.jsx';
import PortfolioSectionStyle2 from '../Section/PortfolioSection/PortfolioSectionStyle2.jsx';
import WorkingProcessSection from '../Section/WorkingProcessSection.jsx';
import TestimonialSliderStyle3 from '../Slider/TestimonialSliderStyle3.jsx';



const testimonialData = [
  {
    imgUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    subTitle:
      "The team did an outstanding job on our kitchen cabinets. The finishing and detailing were beyond our expectations. Highly professional and delivered exactly on time.",
    rating: '5',
    name: 'Michael Thompson',
  },
  {
    imgUrl: 'https://randomuser.me/api/portraits/women/44.jpg',
    subTitle:
      "We hired them for custom wardrobes and interior doors, and the craftsmanship was exceptional. Very reliable and easy to work with throughout the project.",
    rating: '4.5',
    name: 'Sarah Williams',
  },
  {
    imgUrl: 'https://randomuser.me/api/portraits/men/65.jpg',
    subTitle:
      "From design to installation, everything was handled perfectly. Our living room wall paneling looks amazing. I would definitely recommend their carpentry services.",
    rating: '4',
    name: 'David Anderson',
  },
];

const portfolioData = [
  {
    imgUrl: '/images/gallery/1 (1).jpg',
    title: 'Custom Kitchen Cabinet Installation',
    category: 'kitchen',
  },
  {
    imgUrl: '/images/gallery/1 (2).jpg',
    title: 'Modern Wardrobe & Closet Design',
    category: 'interior',
  },
  {
    imgUrl: '/images/gallery/1 (3).jpg',
    title: 'Luxury Wooden Staircase Work',
    category: 'renovation',
  },
  {
    imgUrl: '/images/gallery/1 (4).jpg',
    title: 'Custom Interior Door Installation',
    category: 'doors',
  },
  {
    imgUrl: '/images/gallery/1 (5).jpg',
    title: 'Office Reception Desk Carpentry',
    category: 'commercial',
  },
  {
    imgUrl: '/images/gallery/1 (6).jpg',
    title: 'Bathroom Vanity & Storage Cabinets',
    category: 'bathroom',
  },
  {
    imgUrl: '/images/gallery/1 (7).jpg',
    title: 'Outdoor Deck & Patio Woodwork',
    category: 'outdoor',
  },
  {
    imgUrl: '/images/gallery/1 (8).jpg',
    title: 'Wall Paneling & Feature Walls',
    category: 'interior',
  },
  {
    imgUrl: '/images/gallery/1 (9).jpg',
    title: 'Custom TV Unit & Media Wall',
    category: 'living-room',
  },
  {
    imgUrl: '/images/gallery/1 (10).jpg',
    title: 'Full Home Renovation Woodwork',
    category: 'renovation',
  },
  {
    imgUrl: '/images/gallery/1 (11).jpg',
    title: 'Bespoke Wooden Furniture Design',
    category: 'furniture',
  },
  {
    imgUrl: '/images/gallery/1 (12).jpg',
    title: 'Kitchen Island Custom Build',
    category: 'kitchen',
  },
  {
    imgUrl: '/images/gallery/1 (13).jpg',
    title: 'Sliding Wooden Door Installation',
    category: 'doors',
  },
  {
    imgUrl: '/images/gallery/1 (14).jpg',
    title: 'Retail Store Display Shelving',
    category: 'commercial',
  },
  {
    imgUrl: '/images/gallery/1 (15).jpg',
    title: 'Bedroom Custom Bed Frame',
    category: 'furniture',
  },
  {
    imgUrl: '/images/gallery/1 (16).jpg',
    title: 'Luxury Walk-In Closet Setup',
    category: 'interior',
  },
  {
    imgUrl: '/images/gallery/1 (17).jpg',
    title: 'Restaurant Interior Woodwork',
    category: 'commercial',
  },
  {
    imgUrl: '/images/gallery/1 (18).jpg',
    title: 'Bathroom Mirror Cabinet Installation',
    category: 'bathroom',
  },
  {
    imgUrl: '/images/gallery/1 (19).jpg',
    title: 'Wooden Pergola & Outdoor Shade',
    category: 'outdoor',
  },
  {
    imgUrl: '/images/gallery/1 (20).jpg',
    title: 'Modern Study Table Design',
    category: 'furniture',
  },
  {
    imgUrl: '/images/gallery/1 (21).jpg',
    title: 'Custom Kitchen Storage Solutions',
    category: 'kitchen',
  },
  {
    imgUrl: '/images/gallery/1 (22).jpg',
    title: 'Decorative Ceiling Wood Panels',
    category: 'interior',
  },
  {
    imgUrl: '/images/gallery/1 (23).jpg',
    title: 'Hardwood Flooring Installation',
    category: 'renovation',
  },
  {
    imgUrl: '/images/gallery/1 (24).jpg',
    title: 'Office Conference Table Build',
    category: 'commercial',
  },
  {
    imgUrl: '/images/gallery/1 (25).jpg',
    title: 'Custom Shoe Rack & Entry Storage',
    category: 'interior',
  },
  {
    imgUrl: '/images/gallery/1 (26).jpg',
    title: 'Wooden Window Frame Installation',
    category: 'renovation',
  },
  {
    imgUrl: '/images/gallery/1 (27).jpg',
    title: 'Luxury Bathroom Cabinet Design',
    category: 'bathroom',
  },
  {
    imgUrl: '/images/gallery/1 (28).jpg',
    title: 'Outdoor Garden Wooden Seating',
    category: 'outdoor',
  },
  {
    imgUrl: '/images/gallery/1 (29).jpg',
    title: 'Custom Bookshelf & Library Unit',
    category: 'furniture',
  },
  {
    imgUrl: '/images/gallery/1 (30).jpg',
    title: 'Complete Home Interior Carpentry',
    category: 'renovation',
  },
];


const brandData = [
  { imgUrl: '/images/brand/brand-1-1.png' },
  { imgUrl: '/images/brand/brand-1-2.png' },
  { imgUrl: '/images/brand/brand-1-3.png' },
  { imgUrl: '/images/brand/brand-1-4.png' },
  { imgUrl: '/images/brand/brand-1-5.png' },
  { imgUrl: '/images/brand/brand-1-6.png' },
  { imgUrl: '/images/brand/brand-1-7.png' },
  { imgUrl: '/images/brand/brand-1-8.png' },
  { imgUrl: '/images/brand/brand-1-9.png' },
  { imgUrl: '/images/brand/brand-1-10.png' },
  { imgUrl: '/images/brand/brand-1-11.png' },
  { imgUrl: '/images/brand/brand-1-12.png' },
];

const stepData = [
  {
    imgUrl: 'images/consultation.png',
    title: 'Consultation & Planning',
    desc: 'We discuss your ideas and requirements to create the perfect design plan tailored to your space, including cost estimates and timelines.',
    step: '01',
  },
  {
    imgUrl: 'images/designing.png',
    title: 'Design & Approval',
    desc: '3D sketches and prototypes are created to match your vision. Once you review and approve, production begins.',
    step: '02',
  },
  {
    imgUrl: 'images/craftsmanship.png',
    title: 'Craftsmanship & Production',
    desc: 'High-quality materials are used in every project. We follow strict quality control standards to ensure your satisfaction.',
    step: '03',
  },
  {
    imgUrl: 'images/installation.png',
    title: 'Delivery & Installation',
    desc: 'Once the project is completed, we ensure it is delivered on time and in perfect condition. We also provide installation services if needed.',
    step: '04',
  },
];

export default function Projects() {
  pageTitle('Projects');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb title="Projects" bgUrl="/images/page_header_1.jpeg" />
      <Section
              pt="133"
              ptLg="75"
              pb="115"
              pbLg="55"
              className="background-top-filled"
            >
              <PortfolioSectionStyle2
                sectionTitle="<span className='text-primary-dark'> Explore Our Best <br/> Carpentry Project Work</span>"
                sectionTitleUp="Our Latest Projects"
                sectionSubTitle="Precision-built cabinetry, finish work, and custom wood solutions crafted across Houston."
                data={portfolioData}
                initialShowCount={33}
                hideFilter
                textVarient="text-white"                
                layoutPatternRows={[[2,1],[1,1,1],[1,2]]}
              />
            </Section>

    <div className="cs_pt_140 cs_pb_133">
              <BrandSection data={brandData} />
            </div>
          <Section
            pb='120'
            ptLg="75">
     <WorkingProcessSection
                sectionTitleUp="Working Process"
                sectionTitle="Check How We Work in <br/>  Easy Steps"
                data={stepData}
              />
              </Section>
          <Section >
           
            <div className="cs_pb_131 cs_pt_131 bg-accent" >
             <TestimonialSliderStyle3 data={testimonialData} />
            </div>
          </Section>
    
          {/* <Section pt="133" ptLg="70" pb="75" pbLg="45" className="bg-gray">
            <PostSectionStyle2
              sectionTitleUp="Find The Blogs"
              sectionTitle="Find Out Latest News <br/> and Articles"
              data={postData}
            />
          </Section> */}
    
          {/* <LocationInMap data={locationData} /> */}
          <Section
            pt="80"
            ptLg="75"
            pb="85"
            pbLg="55"
          >
            <ContactSectionStyle2
              sectionTitle="Let’s Build Your Vision"
              sectionTitleUp="Contact Hybrid One Carpentry"
              sectionSubTitle="Custom cabinetry, millwork, doors, and furniture tailored to your space. Serving Greater Houston with precision craftsmanship — request a free estimate today."
              featureList={[
                'Free site visit & estimate',
                'Licensed, insured workmanship',
                'Custom design options',
                'High-quality materials',
                'On-time project delivery',
              ]}
              contactInfo={[
                {
                  imgUrl: '/images/icons/contact_icon_1.svg',
                  titleUp: 'Have Any Question?',
                  title: '+1 (281) 409 5882',
                  textColor: 'text-primary',
                },
                {
                  imgUrl: '/images/icons/contact_icon_2.svg',
                  titleUp: 'Send Email',
                  title: 'manager@hybridonecarpentry.com',
                  textColor: 'text-primary',
                },
              ]}
            />
          </Section>
    </>
  );
}
